// SubscriptionCard.jsx
import React from "react";
import { subscriptionOffers } from "@/mock/subscription";
import Icon from "../Icon";
import "./styles.scss";
import { useSubscriptionToken } from "@/hooks/useSubscriptionToken";

export const SubscriptionCard = () => {
  const { subscriptionUrl } = useSubscriptionToken();

  return (
    <div className="subscription-card">
      <div className="subscription-card__inner">
        <div className="subscription-card__icon">
          <Icon name="subscription" />
        </div>
        <div className="subscription-card__header">
          <h2 className="subscription-card__title">
            You don't Have Access to this Content
          </h2>
          <p className="subscription-card__subtitle">
            Gain Access To More Unique Learning Content
          </p>
        </div>
        <div className="subscription-card__offers">
          {subscriptionOffers.map((item, index: number) => (
            <div key={index} className="subscription-card__offer-item">
              <Icon name="primaryCheck" />
              <span className="subscription-card__offer-text">
                {item.title}
              </span>
            </div>
          ))}
        </div>
        <div className="subscription-card__button-container">
          <a
            style={{ opacity: subscriptionUrl ? 1 : 0.5 }}
            href={
              !subscriptionUrl
                ? "https://www.pluritongues.com/pricing"
                : `https://www.pluritongues.com/${subscriptionUrl}`
            }
            className="subscription-card__button"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="subscription-card__button-text">Continue</span>
          </a>
        </div>
      </div>
    </div>
  );
};
